import { createSlice } from "@reduxjs/toolkit";
import { versionControl } from "../services/operations/versionControlApi";

const initialState = {
  versions: [],
  selectedVersion: null,
  status: "idle",
  error: null,
  currentPage: 1,
  totalPages: 1,
  lastEvaluatedKey: null,
};

const versionControlSlice = createSlice({
  name: "versionControl",
  initialState,
  reducers: {
    setSelectedVersion: (state, action) => {
      state.selectedVersion = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    resetCurrentPage: (state) => {
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(versionControl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(versionControl.fulfilled, (state, action) => {
        switch (action.payload.actionType) {
          case "list":
            state.versions = action.payload.data.items;
            state.totalPages = action.payload.data.total_pages;
            state.lastEvaluatedKey = action.payload.data.last_evaluated_key;
            state.status = "succeeded";
            break;
          case "create":
            state.versions.push(action.payload.data);
            break;
          case "update":
            const index = state.versions.findIndex(v => v.version === action.payload.data.version);
            if (index !== -1) {
              state.versions[index] = action.payload.data;
            }
            break;
          default:
            break;
        }
      })
      .addCase(versionControl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setSelectedVersion, setCurrentPage,resetCurrentPage } = versionControlSlice.actions;
export default versionControlSlice.reducer;

